import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first, finalize } from 'rxjs/operators';
import { AuthService } from '../_services/auth.service';
import { AlertService } from '../_services/alert.service';
import { UserService } from '../share/services/user.service';
import { NavigationService } from '../share/services/navigation.service';
import { LocalStorageService } from '../share/services/local-storage.service';

@Component({
    templateUrl: 'login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
    loginForm: FormGroup;
    loading = false;
    submitted = false;
    returnUrl: string;
    showPassword = false;
    
    constructor(
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private alertService: AlertService,
        public authService: AuthService,
        private userService: UserService,
        private navigationService: NavigationService,
        private localStorageService: LocalStorageService) { }

    ngOnInit() {
        this.loginForm = this.formBuilder.group({
            email: ['', Validators.required],
            password: ['', Validators.required]
        });
        this.route.queryParams
        .subscribe(params => this.returnUrl = params['return']);

        if (localStorage.getItem('currentUser')) {
            this.authService.doLogout();
        }
    }

    // convenience getter for easy access to form fields
    get f() { return this.loginForm.controls; }

    togglePasswordVisibility() {
        this.showPassword = !this.showPassword;
    }

    tryLogin() {
        if (this.loginForm.invalid) {
            return;
        }
        this.submitted = true;
        let email = this.loginForm.get('email').value;
        let password = this.loginForm.get('password').value;

        this.userService.login(email, password)
            .pipe(finalize(() => {
                //this.isLoading = false;
                //this.changeDetectorRef.detectChanges();
            }))
            .subscribe(
                (user) => {
                    console.log("USER ", user);
                    this.localStorageService.setUser(user);
                    if (this.returnUrl) {
                        this.router.navigateByUrl(this.returnUrl);
                    } else {
                        if (user.isSuperAdmin()) {
                            this.navigationService.goToClients();
                        } else if (user.isCollaborator()) {
                            this.navigationService.goToPollResponse();
                        } else {
                            this.navigationService.goToHome();
                        }
                    }
                },
                (err) => {
                    console.log("ERR ", err);
                    this.submitted = false;
                }
            )
    }

    setUserInStorage(res) {
        if (res.user) {
            localStorage.setItem('currentUser', JSON.stringify(res.user));
        } else {
            localStorage.setItem('currentUser', JSON.stringify(res));
        }
    }
}
